export const message = {
    REQUIRED_FIELD: "This field is required",
    SAVE_SUCCESS: "Changes saved successfully",
    fieldSourceType:"Accept the source type, SQL/CRM/API only.",
    fieldSourceId: "Field should contain name of sp or api in case of SQL/CRM or API.",
    fieldParameter: "This field will accept Json only."
};
